//!!!!! TODO: Do not mutate state directly fix it asap!!!!!!
import React from 'react'
import i18 from '../../../../i18'
import Invoice from "../../../nav/invoice";

class RowUnprocessed extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            invoice: props.invoice,
            invoiceItem: props.invoiceItem,
            keyIndex: props.keyIndex,
            supplier_name_checkbox: false,
            supplier_name: props.invoice.supplier.name,
            invoice_number: props.invoice.invoiceNumber,
            item_name_checkbox: false,
            item_name: props.invoiceItem.lineDescription,
            main_bookkeeping_number: '',
            vat: props.invoiceItem.vatPercentage * 100,
            vat_collector_id: '',
            vat_degree: '',
            vatCollectorCodes: props.vatCollectorCodes,
            showInvoice: false
        };
    };

    onElementChange = (event) => {
        // todo: check
        this.setState({
            [event.target.attributes.name.nodeValue]: (
                event.target.type === 'checkbox'
                    ? event.target.checked
                    : event.target.value
            )
        });
    };

    onShowInvoice = () => {
        this.setState({
            showInvoice: !this.state.showInvoice,
        })
    }

    onCreateRule = (event) => {
        if (!this.state.main_bookkeeping_number || !this.state.vat_collector_id || !this.state.vat_degree) {
            this.props._addNotification('Kérünk ellenőrizze a kötelező mezőket: 	Fők. szám, Gyűjtő kód, 	ÁFA fők. szám', 'error', 30);
            return;
        }

        if (!this.state.supplier_name_checkbox && !this.state.item_name_checkbox) {
            this.props._addNotification('A szállítót vagy a tételt muszáj megjelölni', 'error', 30);
            return;
        }

        let ruleData = {
            supplier_name: this.state.supplier_name_checkbox ? this.state.supplier_name : '',
            item_name: this.state.item_name_checkbox ? this.state.item_name : '',
            vat: this.state.vat,
            type: event.target.attributes.name.nodeValue,

            main_bookkeeping_number: this.state.main_bookkeeping_number,
            vat_collector_id: this.state.vat_collector_id,
            vat_degree: this.state.vat_degree,
        };

        this.props.onCreateRule(event, ruleData);
    };

    deleteInvoiceItem = () => {
        this.props.deleteInvoiceItem(this.state.keyIndex);
        this.props._addNotification('A tétel törölve lett a kimenetből', 'warning', 30);
    }

    deleteInvoice = () => {
        this.props.deleteInvoice(this.props.invoiceIndex);
        this.props._addNotification('A számla törölve lett a kimenetből', 'warning', 30);
    }

    render() {
        let supplier_name_checkbox_id = Math.random(9999, 99999);
        let item_name_checkbox_id = Math.random(9999, 99999);
        return (
            <React.Fragment>
                <tr key={this.state.key}>
                    <td>
                        <input
                            id={supplier_name_checkbox_id}
                            name="supplier_name_checkbox"
                            value={this.state.supplier_name_checkbox}
                            type="checkbox"
                            onChange={(event) => this.onElementChange(event)}/>
                        <label htmlFor={supplier_name_checkbox_id}>&nbsp;&nbsp;{this.state.supplier_name}</label>
                    </td>
                    <td>
                        <a onClick={(event) => this.onShowInvoice()} title="Számlakép">
                            {this.state.invoice.invoiceNumber}
                        </a>
                    </td>
                    <td>
                        <input
                            id={item_name_checkbox_id}
                            name='item_name_checkbox'
                            value={this.state.item_name_checkbox}
                            type="checkbox"
                            onChange={(event) => this.onElementChange(event)}/>
                        <input
                            name='item_name'
                            onChange={(event) => this.onElementChange(event)}
                            value={this.state.item_name}
                            className='typeOfTraffic no-border-underline-text-input'
                            type='text'/>
                    </td>
                    <td>
                        <input
                            name='main_bookkeeping_number'
                            value={this.state.main_bookkeeping_number}
                            onChange={(event) => this.onElementChange(event)}
                            className='bordered-input'
                            type='text'/>
                    </td>
                    <td>{parseInt(this.state.vat, 0)}%</td>
                    <td>
                        <select value={this.state.vat_collector_id}
                                name='vat_collector_id'
                                onChange={(event) => this.onElementChange(event)}
                                className='minimal form-control'>
                            <option value='' key='0'>Kérjük válasszon</option>
                            {this.state.vatCollectorCodes
                                ? this.state.vatCollectorCodes.map((el) => {
                                    return <option value={el.id} key={el.id}>{el.code}&nbsp;({el.title})</option>
                                })
                                : ''
                            }
                        </select>
                    </td>
                    <td>
                        <input
                            name='vat_degree'
                            onChange={(event) => this.onElementChange(event)}
                            value={this.state.vat_degree}
                            className='bordered-input'
                            type='text'/>
                    </td>
                    <td>
                        <i onClick={(event) => this.onCreateRule(event)} name='final' title={i18.SUPPLIER._createRulesAndProcess} className='fa fa-dot-circle-o' aria-hidden='true'></i> &nbsp;
                        <i onClick={(event) => this.onCreateRule(event)} name='temporarily' title={i18.SUPPLIER._oneTimeProcessing} className='fa fa-check-circle' aria-hidden='true'></i> &nbsp;
                        <i onClick={(event) => this.deleteInvoiceItem()} title='Tétel törlése a kimenetből' className='fa fa-trash-o' aria-hidden='true'></i> &nbsp;
                        <i onClick={(event) => this.deleteInvoice()} title='Számla törlése a kimenetből' className='fa fa-trash' aria-hidden='true'></i>
                    </td>
                </tr>
                {this.state.showInvoice
                    ? <tr>
                        <td colSpan="8">
                            <Invoice
                                {...this.props}
                                invoice={this.state.invoice}
                            />
                        </td>
                    </tr>
                    : null}
            </React.Fragment>
        );
    }
}

export default RowUnprocessed


// WEBPACK FOOTER //
// ./src/components/supplier/steps/assignment/RowUnprocessed.js